(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CheckCEPCountryFactory', CheckCEPCountryFactory);

    CheckCEPCountryFactory.$inject = ['$resource'];

    function CheckCEPCountryFactory($resource) {
        var resourceUrl =  'zipcode/api/country';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
